<nz-form-item class="ui-form-time">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
      label | localization
    }}</nz-form-label>
  <nz-form-control
    [nzValidateStatus]="control ?? 'success'"
    [nzErrorTip]="errorTip | localization"
  >
    <nz-time-picker
      [(ngModel)]="value"
      (ngModelChange)="onDateChanged($event)"
      [nzFormat]="format"
      nzDropdownClassName="ui-form-date-dropdown"
      [nzPlaceHolder]="placeholder | localization"
      [disabled]="disabled"
      [nzInputReadOnly]="true"
      [nzBackdrop]="true"
    ></nz-time-picker>
  </nz-form-control>
</nz-form-item>
